import React from "react";
import { graphql } from "gatsby";

export default function Ugc() {
  return (
    <div className="pt-16">
      <div className="flex flex-col items-center hds-copy hds-text-colo mx-auto container text-center">
        <p className="hds-title__medium mb-xs md:mb-sm font-bold font-heading bold-color hds-text-color">
          #Thermacell
        </p>
      </div>
      <div className="">
        <div
          class="tintup"
          data-id="thermacell_instagram"
          data-columns="2"
          data-expand="true"
          style={{
            height: "500px",
            width: "100%",
          }}
          data-personalization-id="1084485"
          data-infinitescroll="true"
        />
      </div>
    </div>
  );
}
